import { v4 as uuidv4 } from 'uuid';
import { useEffect, useState, useRef, memo , useCallback} from "react";
import {  useSelector } from 'react-redux';
import {
  GetShareLink,
  duplicatePrjoectJSON,
  getAssetData,
  getProjectJSON,
  projectExportApi,
  getApikeysConfig,
  getSubtitleSentences,
  getSubtitleInfo,
  uploadtoInstagram,
  getChatGPTLLMTranslation,
  postChatGPTLLMTranslation,
  AIShortItemManifestPost,
  AIShortManifestPost,
  AIShortManifestGet,
  AIShortManifestUpdate
} from "../../../../axios/ApiProvider";
import { getTotalProjectTime } from '../../timeline/common/commonFunction';
import cloneDeep from 'lodash/cloneDeep';
import { getNewTextInformation } from '../../webGL/commonFunc';
import ReactLoading from 'react-loading'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { convertStringtoWStringUTF16 } from '../../commonFunction';
import Swal from 'sweetalert2';
import {Box, Button, Card,Dialog,DialogActions,DialogContent,DialogTitle,Grid, Stack,TextField, Typography,Divider,IconButton,
  Tooltip, MenuItem,Snackbar,Alert
} from "@mui/material";
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import SvgIcon from '@mui/material/SvgIcon';
import ShareIcon from '@mui/icons-material/Share';
import copy from "copy-to-clipboard";
import { min } from 'lodash';
import { languageToList1 } from '../tooltap.aisummary.js';
const INSTAGRAM_DESCRIPTION_LIMIT = 2100;

// import {chapterList, chapterProject, chapterReExports, chapterTopics} from "./testData"

const HOME_FRONTEND_URL = process.env.REACT_APP_BASE_FRONTEND_URL || window.location.origin;
let mobileScreenDetect = false
  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(navigator.userAgent||navigator.vendor||window.opera)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test((navigator.userAgent||navigator.vendor||window.opera).substr(0,4))){
    mobileScreenDetect = true;
  }
const TikTokIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {/* Simple, stylized TikTok-like icon */}
    <path d="M13 3v4.2c.7.8 1.5 1.4 2.4 1.8.7.3 1.4.4 2.1.4V7.3c-.4-.1-.8-.2-1.2-.4-.7-.3-1.3-.8-1.9-1.4V3h-1.4zM9.5 9a3.5 3.5 0 1 0 2.8 5.7l-1-.6a2.2 2.2 0 1 1-1.8-3.5c.7 0 1.2.3 1.6.7v-2A3.5 3.5 0 0 0 9.5 9z" />
  </SvgIcon>
);

const formatTime = (seconds) => {
  const hrs = Math.floor(seconds / 3600).toString().padStart(2, '0');
  const mins = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
  const secs = Math.floor(seconds % 60).toString().padStart(2, '0');
  const millis = ((seconds % 1) * 1000).toFixed(0).padStart(3, '0'); // Extract milliseconds

  return `${hrs}:${mins}:${secs}:${millis}`;
};

const loadScript = (src, callback) => {
  const script = document.createElement('script');
  script.src = src;
  script.onload = callback;
  document.body.appendChild(script);
};

const loadCSS = (href) => {
  const link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  document.head.appendChild(link);
};

function getLocalDate() {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().split("T")[0];
}

function getLocalTime() {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().split("T")[1].slice(0, 5);
}

function areEqual(prevProps, nextProps) {
  const prev = prevProps.chapterExport;
  const next = nextProps.chapterExport;

  // Only rerender if progress/exported/uploadedtoInstagram changed
  return (
    prev?.progress === next?.progress &&
    prev?.exported === next?.exported &&
    prev?.uploadedtoInstagram === next?.uploadedtoInstagram
    &&prev?.shareUrl === next?.shareUrl 
  );
}

const ChapterCard = memo(function ChapterCard({
  chapterItem,
  chapterData,
  chapterProject,
  chapterExport,
  calculateDuration,
  onClickOpenProject,
  onDownloadShort,
  openInstagramUploadModal,
  setChapterReExports,
  openFacebookUploadModal,
  openLinkedinUploadModal, 
  onCopyLink, 
  onGenerateShareLink,

}) {
  const shareUrl = chapterExport?.shareUrl;

  const handleShareClick = async () => {
  if (!chapterExport?.exported) {
    Swal.fire({
      icon: "info",
      title: "Share link not ready",
      text: "Please wait for the short to be exported.",
    });
    return;
  }

  let finalShareUrl = shareUrl || null;

  if (!finalShareUrl && onGenerateShareLink && chapterExport?.asset_uuid) {
    const createdUrl = await onGenerateShareLink(
      chapterExport.asset_uuid,
      chapterItem
    );
    finalShareUrl = createdUrl || null;
  }

  if (!finalShareUrl) {
    Swal.fire({
      icon: "error",
      title: "Share link could not be created",
      text: "Asset uuid or project uuid is looking invalid.",
    });
    return;
  }

  if (onCopyLink) {
    onCopyLink(finalShareUrl, "Share link copied");
  }
};


return (
    <Grid item xs={12} md={6} lg={4}>
      <Card sx={{ width: '100%', padding: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: "column" }}>
        <Box padding={1} width={'100%'}>
            <Card sx={{ width: '100%', padding: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: "column" }}>
              <Box padding={1} width={'100%'}>
                <Typography
                  marginBottom={2}
                  align='center'
                  sx={{
                    textDecoration: 'underline',
                    fontSize: { xs: '14px', sm: '16px', md: '18px', lg: '20px' }
                  }}
                >
                  {chapterData.topic}
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: {
                      md: 'row',
                      xs: 'column-reverse'
                    },
                    alignItems: {
                      md: 'unset',
                      xs: 'center'
                    }
                  }}
                  gap={1}
                  mb={2}
                >
                  {/* START: Modified Stack for horizontal grouping */}
                  <Stack direction="column" spacing={2} sx={{ userSelect: 'none', minWidth: '150px', width: '100%' }}>

                    {/* Start Timestamp and End Timestamp on the same line */}
                    <Stack direction="row" spacing={1}>
                      <TextField
                        variant="outlined"
                        size="small"
                        label="Start Timestamp"
                        fullWidth
                        value={formatTime(parseFloat(chapterData.new_timestamps[0].split('-')[0]).toFixed(2)) || 0}
                        sx={{
                          display: {
                            md: 'block',
                          },
                          marginTop: { xs: 1, md: 0 }
                        }}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            userSelect: 'none',
                            '& input': {
                              fontSize: '0.75rem',
                              pointerEvents: 'none'
                            }
                          }
                        }}
                      />

                      <TextField
                        variant="outlined"
                        size="small"
                        label="End Timestamp"
                        fullWidth
                        value={formatTime(parseFloat(chapterData.new_timestamps[0].split('-')[1]).toFixed(2)) || 0}
                        sx={{
                          display: {
                            md: 'block',
                          },
                        }}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            userSelect: 'none',
                            '& input': {
                              fontSize: '0.75rem',
                              pointerEvents: 'none'
                            }
                          }
                        }}
                      />
                    </Stack>

                    {/* Importance and Duration on the same line */}
                    <Stack direction="row" spacing={1}>
                      <TextField
                        variant="outlined"
                        size="small"
                        label="Importance"
                        fullWidth
                        value={chapterData.importance || 0}
                        sx={{
                          display: {
                            md: 'block',
                          },
                        }}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            userSelect: 'none',
                            '& input': {
                              fontSize: '0.75rem',
                              pointerEvents: 'none'
                            }
                          }
                        }}
                      />

                      <TextField
                        variant="outlined"
                        size="small"
                        label="Duration"
                        fullWidth
                        value={formatTime(calculateDuration(chapterData.new_timestamps))}
                        sx={{
                          display: {
                            md: 'block',
                          },
                        }}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            userSelect: 'none',
                            '& input': {
                              fontSize: '0.75rem',
                              pointerEvents: 'none'
                            }
                          }
                        }}
                      />
                    </Stack>
                    {/* END: Modified Stack for horizontal grouping */}

                    {chapterData?.new_transcript &&
                      <TextField
                        variant="outlined"
                        size="small"
                        label="Transcript"
                        multiline
                        maxRows={6}
                        fullWidth
                        value={chapterData?.new_transcript}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            fontSize: '0.75rem',
                            display: "block",
                            userSelect: 'none',
                            '& input': {
                              display: "block",
                              pointerEvents: 'none'
                            }
                          }
                        }}
                      />
                    }

                    <Box display={"flex"} gap={1} flexDirection={'column'} marginBottom={2}>
                      <Button
                        disabled={!!chapterExport?.progress == false}
                        onClick={() => {
                          onClickOpenProject(chapterData, chapterProject?.projID)
                        }}
                        fullWidth
                        variant="outlined"
                      >
                        Edit Project
                      </Button>

                      <Button
                        disabled={!!chapterExport?.exported == false}
                        onClick={() => {
                          onDownloadShort(chapterExport.videoUrl)
                        }}
                        fullWidth
                        variant="contained"
                      >
                        Download Short
                      </Button>

                      {/* Social upload icon row */}
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap={1}
                    mt={1}
                  >
                    {/* Instagram */}
                    <Tooltip title={
                      chapterExport?.uploadedtoInstagram
                        ? "Uploaded to Instagram"
                        : "Upload to Instagram"
                    }>
                      {/* for span  disabled IconButton + Tooltip */}
                      <span>
                        <IconButton
                          size="small"
                          color={chapterExport?.uploadedtoInstagram ? "success" : "primary"}
                          disabled={!chapterExport?.exported}
                          onClick={() => {
                            if (!chapterExport?.exported) return;

                            setChapterReExports(prev => ({
                              ...prev,
                              [chapterItem]: {
                                ...prev[chapterItem],
                                uploadedtoInstagram: true,
                              },
                            }));

                            openInstagramUploadModal(chapterExport.asset_uuid);
                          }}
                        >
                          <InstagramIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>

                                        {/* Facebook */}
                    <Tooltip title="Share on Facebook">
                              <span>
                                <IconButton
                                  size="small"
                                  disabled={!chapterExport?.exported}
                                  onClick={async () => {
                                    if (!chapterExport?.exported || !chapterExport?.videoUrl) return;

                                    navigator.clipboard.writeText(chapterExport.videoUrl);
                                    Swal.fire({
                                      icon: "success",
                                      title: "Copied link for Facebook",
                                      text: "You Can Share On Facebook.",
                                    });
                                  }}
                                >
                                  <FacebookIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </Tooltip>



                                        {/* LinkedIn */}
                   <Tooltip title="Share on LinkedIn">
                        <span>
                          <IconButton
                            size="small"
                            disabled={!chapterExport?.exported}
                            onClick={async () => {
                              if (!chapterExport?.exported || !chapterExport?.videoUrl) return;

                              navigator.clipboard.writeText(chapterExport.videoUrl);
                              Swal.fire({
                                icon: "success",
                                title: "Copied link for LinkedIn",
                                text: "You Can Share On LinkedIn.",
                              });
                            }}
                          >
                            <LinkedInIcon fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>


                    {/* YouTube */}
                   {/* YouTube */}
                <Tooltip title="Share on YouTube">
                  <span>
                    <IconButton
                      size="small"
                      disabled={!chapterExport?.exported}
                      onClick={async () => {
                        if (!chapterExport?.exported || !chapterExport?.videoUrl) return;

                        navigator.clipboard.writeText(chapterExport.videoUrl);
                        Swal.fire({
                          icon: "success",
                          title: "Copied link for YouTube",
                          text: "You Can Share On YouTube.",
                        });
                      }}
                    >
                      <YouTubeIcon fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>

                {/* TikTok */}
                <Tooltip title="Share on TikTok">
                  <span>
                    <IconButton
                      size="small"
                      disabled={!chapterExport?.exported}
                      onClick={async () => {
                        if (!chapterExport?.exported || !chapterExport?.videoUrl) return;

                        navigator.clipboard.writeText(chapterExport.videoUrl);
                        Swal.fire({
                          icon: "success",
                          title: "Copied link for TikTok",
                          text: "You Can Share On TikTok.",
                        });
                      }}
                    >
                      <TikTokIcon fontSize="small" />
                    </IconButton>
                  </span>
                </Tooltip>
                  </Box>

                    </Box>
                    {chapterExport?.exported && (
                  <Box
                    display="flex"
                    justifyContent="center"
                    mt={1}
                  >
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<ShareIcon fontSize="small" />}
                      onClick={handleShareClick}
                       disabled={!chapterExport?.exported}
                      sx={{
                        textTransform: 'none',
                        fontSize: '0.75rem',
                        px: 2,
                      }}
                    >
                      Share link
                    </Button>
                  </Box>
                )}

                  </Stack>

                  {chapterExport?.exported == true && (
                    <Box
                      sx={{
                        width: '100%',
                        maxWidth: 220,
                        aspectRatio: '9 / 16',
                        position: 'relative',
                        background: '#000',
                        borderRadius: 2,
                        overflow: 'hidden',
                        ...(typeof window !== "undefined" && !CSS.supports('aspect-ratio: 1 / 1')
                          ? {
                            height: `calc(220px * 16 / 9)`
                          }
                          : {})
                      }}
                    >
                      <video
                        className='ai-short-export-video'
                        controls
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'contain',
                          display: 'block',
                        }}
                        src={chapterExport.videoUrl}
                      />
                    </Box>
                  )}

                  {chapterExport?.progress == null &&
                    <Box
                      border={1}
                      borderRadius={2}
                      display={'flex'}
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        width: '100%',
                        maxWidth: '220px',
                        aspectRatio: '9 / 16',
                        position: 'relative',
                        ...(typeof window !== "undefined" && !CSS.supports('aspect-ratio: 1 / 1')
                          ? {
                            height: `calc(220px * 16 / 9)`
                          }
                          : {})
                      }}
                    >
                      💤
                    </Box>
                  }


                  {chapterExport?.exported === false && (
                    <Box
                      border={1}
                      borderRadius={2}
                      display={'flex'}
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        maxWidth: 220,
                        width: "100%",
                        aspectRatio: '9 / 16',
                        ...(typeof window !== "undefined" && !CSS.supports('aspect-ratio: 1 / 1')
                          ? { height: `calc(220px * 16 / 9)` }
                          : {})
                      }}
                    >
                      {chapterExport.progress > 2 ? (
                        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                          <ReactLoading type="spin" className="loading-icon" />
                          <Typography
                            variant="h6"
                            sx={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)',
                              fontWeight: 'bold'
                            }}
                          >
                            {`${chapterExport.progress}%`}
                          </Typography>
                        </Box>
                      ) : (
                        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                          <ReactLoading type="spin" className="loading-icon" />
                          <Typography
                            variant="h6"
                            sx={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)',
                              fontWeight: 'bold'
                            }}
                          >
                            💫
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  )}

                </Box>

                {chapterData?.comment.trim() !== "" &&
                  <Box sx={{ position: 'relative', display: { md: 'block' } }}>
                    <TextField
                      variant="outlined"
                      size="small"
                      label="Comment "
                      fullWidth
                      multiline
                      rows={4}
                      value={chapterData.comment}
                      InputProps={{
                        readOnly: true,
                        sx: {
                          paddingRight: 2.5,
                          fontSize: '0.75rem',
                          userSelect: 'none',
                          '& input': {
                            pointerEvents: 'none'
                          }
                        }
                      }}
                    />

                    <Tooltip title="Copy">
                      <IconButton
                        size="small"
                        onClick={() =>
                          navigator.clipboard.writeText(chapterData.comment || '')
                        }
                        sx={{
                          position: 'absolute',
                          bottom: 0,
                          right: -4,
                          '&:hover': { opacity: 0.8 }
                        }}
                      >
                        <ContentCopyIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                }
              </Box>
            </Card>
        </Box>
      </Card>
    </Grid>
  );},areEqual);

const ChaptersGrid = memo(function ChaptersGrid({
  chapterTopics,
  chapterList,
  chapterProject,
  chapterReExports,
  onClickOpenProject,
  onDownloadShort,
  setChapterReExports,
  openInstagramUploadModal,
  openFacebookUploadModal,
  openLinkedinUploadModal,
  calculateDuration,
  onCopyLink,
  onGenerateShareLink,
}) {
  return (
    <Card sx={{ width: '100%', padding: 0 }}>
      <Grid container spacing={0}>
        {chapterTopics.map((chapterItem, key) => (
          <ChapterCard
            key={chapterItem}
            chapterItem={chapterItem}
            chapterData={chapterList[chapterItem]}
            chapterProject={chapterProject[chapterItem]}
            chapterExport={chapterReExports[chapterItem]}
            openFacebookUploadModal={openFacebookUploadModal}
            openLinkedinUploadModal={openLinkedinUploadModal} 
            calculateDuration={calculateDuration}
            onClickOpenProject={onClickOpenProject}
            onDownloadShort={onDownloadShort}
            openInstagramUploadModal={openInstagramUploadModal}
            setChapterReExports={setChapterReExports}
            onCopyLink={onCopyLink} 
            onGenerateShareLink={onGenerateShareLink}
          />
        ))}
      </Grid>
    </Card>
  );
});

const InstagramUploadDialog = memo(function InstagramUploadDialog({
  open,
  onClose,
  activeAssetUUID,
  onPublish,           // (asset_uuid, { instagramDescription, publishDate, publishTime, instagramUsername }) => void
  instagramAccounts,   // AiShortModal'dan geliyor
}) {
  const [instagramDescriptionLocal, setInstagramDescriptionLocal] = useState('');

  const now = new Date();
  const defaultDate = now.toISOString().split("T")[0];
  const defaultTime = now.toTimeString().slice(0, 5);

  const [publishDateLocal, setPublishDateLocal] = useState(getLocalDate());
  const [publishTimeLocal, setPublishTimeLocal] = useState(getLocalTime());
  const [selectedAccountUsername, setSelectedAccountUsername] = useState('');

  useEffect(() => {
    if (open) {
      const now = new Date();
      setPublishDateLocal(now.toISOString().split("T")[0]);
      setPublishTimeLocal(now.toTimeString().slice(0, 5));
    }
  }, [open]);

  useEffect(() => {
    if (instagramAccounts && instagramAccounts.length > 0) {
      setSelectedAccountUsername(instagramAccounts[0].username);
    } else {
      setSelectedAccountUsername('');
    }
  }, [instagramAccounts]);
  const handleDescriptionChange = (e) => {
    const value = e.target.value || "";

    if (value.length <= INSTAGRAM_DESCRIPTION_LIMIT) {
      setInstagramDescriptionLocal(value);
    } else {
      setInstagramDescriptionLocal(value.slice(0, INSTAGRAM_DESCRIPTION_LIMIT));
    }
  };

  const handlePublish = () => {
    onPublish(activeAssetUUID, {
      instagramDescription: instagramDescriptionLocal,
      publishDate: publishDateLocal,
      publishTime: publishTimeLocal,
      instagramUsername: selectedAccountUsername,
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableEnforceFocus
      disableScrollLock
      BackdropProps={{
        style: {
          backgroundColor: 'transparent',
          backdropFilter: 'blur(1px)'
        }
      }}
    >
      <DialogTitle>Publish to Instagram</DialogTitle>
      <DialogContent>
      {instagramAccounts?.length > 0 && (
        <TextField
          select
          label="Instagram Account"
          margin="normal"
          fullWidth
          value={selectedAccountUsername}
            onChange={(e) => setSelectedAccountUsername(e.target.value)}
          >
          {instagramAccounts.map((acc) => (
            <MenuItem key={acc.username} value={acc.username}>
              {acc.username}
            </MenuItem>
          ))}
        </TextField>
      )} 
      <TextField
        label="Instagram Description"
        multiline
        rows={4}
        fullWidth
        value={instagramDescriptionLocal}
        onChange={handleDescriptionChange} 
        inputProps={{
          maxLength: INSTAGRAM_DESCRIPTION_LIMIT,
  }}
/>


        <Typography
          variant="caption"
          sx={{ display: "block", textAlign: "right", mt: 0.5 }}
        >
          {instagramDescriptionLocal.length} / {INSTAGRAM_DESCRIPTION_LIMIT}
        </Typography>
        <TextField
          label="Publish Date"
          type="date"
          margin="normal"
          InputLabelProps={{ shrink: true }}
          value={publishDateLocal}
          onChange={(e) => setPublishDateLocal(e.target.value)}
          inputProps={{ min: defaultDate }}
        />
        <TextField
          label="Publish Time"
          type="time"
          margin="normal"
          InputLabelProps={{ shrink: true }}
          value={publishTimeLocal}
          onChange={(e) => setPublishTimeLocal(e.target.value)}
          inputProps={{
            min:
              publishDateLocal === defaultDate
                ? defaultTime
                : "00:00",
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handlePublish}>Publish</Button>
      </DialogActions>
    </Dialog>
  );
});

export const AiShortModal = ({ 
                              modalOpen, 
                              onModalCancel, 
                              modalData, 
                              subtitleData, 
                              subtitleUUID, 
                              isAiShortModalActivated, 
                              setIsAiShortModalActivated, 
                              isDirectAIShort,
                              aiShortsDuration,
                              textWithDetails,
                              languageInitials,
                              subtitlesTargetLanguage,
                              assetUUID,
                              aiShortsNumber,
                              hasTitle,
                              hasPart
                            }) => {
  const projectUUID = useSelector((store) => store.projectdata.projectUUID);
  const [chapterList, setChapterList] = useState({});
  const [chapterTopics, setChapterTopics] = useState([]);
  const [chapterProject, setChapterProject] = useState({});

  const [AIShortUUID, setAIShortUUID] = useState(null);
  
  const ProjectJSON = useSelector(store => store.projectdata.projectJSON);
  const projectDuration = ProjectJSON?.duration;
  
  const [shortLoaded, setShortLoaded] = useState(false)
  let chapterExports = {};
  const [chapterReExports, setChapterReExports] = useState({});
  const [instagramAccounts, setInstagramAccounts] = useState([]);
  const [youtubeAccounts, setYoutubeAccounts] = useState([]); 
  const [tiktokAccounts, setTiktokAccounts] = useState([]);
  const [facebookAccounts, setFacebookAccounts] = useState([]);
  const [linkedinAccounts, setLinkedinAccounts] = useState([]);

  const languageStrs = useSelector((store) => store.editdata.languageStrs)

  // 1. Keep this Ref at the top
  const manifestResultRef = useRef(null);
  const manifestPromiseRef = useRef(null);

    useEffect(() => {
      const fetchSocialAccounts = async () => {
      try {
      const apiKeyRes = await getApikeysConfig();
      const config = apiKeyRes.data?.config || {};

      const instagram = config.instagram || [];
      const facebook  = config.facebook  || [];  
      const linkedin  = config.linkedin  || [];
      const youtube   = config.youtube   || [];

      setInstagramAccounts(instagram);
      setFacebookAccounts(facebook);
      setLinkedinAccounts(linkedin);
      setYoutubeAccounts(youtube);

      console.log("Instagram accounts:", instagram);
      console.log("Facebook accounts:", facebook);
      console.log("LinkedIn accounts:", linkedin);
      console.log("YouTube accounts:", youtube);
    } catch (e) {
      console.error("Social accounts fetch error", e);
    }
  };

  fetchSocialAccounts();
}, []);


  function convertStringWithDelimiter(str, maxLength = 33, delimiter = '\n') {
    let result = [];

    for (let i = 0; i < str.length; i += maxLength) {
      let chunk = str.slice(i, i + maxLength);

      // Add "..." if the chunk is exactly maxLength AND more text remains
      if (chunk.length === maxLength && i + maxLength < str.length) {
        chunk += "";
      }

      result.push(chunk);
      break;
    }

    return result.join(delimiter);
  }

  const subtitleTemplates = [
    {
      bold: "",
      italic: "",
      alignment: "center",
      font_size: 19,
      text_color: "#26ff00ff", //yellow
      outline_color : "#000000ff",
      font_family: "SuezOne",
      background_color: "#00000000",
    },
    {
      bold: "",
      italic: "",
      alignment: "center",
      font_size: 20,
      text_color: "#ffff00ff", //yellow
      outline_color : "#000000ff",
      font_family: "AlfaSlabOne",
      background_color: "#00000000",
    },
    {
      bold: "",
      italic: "",
      alignment: "center",
      font_size: 16,
      text_color: "#e151afff", //purple
      outline_color : "#000000ff",
      font_family: "KronaOne",
      background_color: "#00000000",
    },
    {
      bold: "",
      italic: "",
      alignment: "center",
      font_size: 18,
      text_color: "#ffa500ff", //orange
      outline_color : "#000000ff",
      font_family: "Goldman",
      background_color: "#00000000",
    },
    {
      bold: "",
      italic: "",
      alignment: "center",
      font_size: 16,
      text_color: "#ffffffff", //white
      outline_color : "#000000ff",
      font_family: "RammettoOne",
      background_color: "#00000000",
    },
    {
      bold: "",
      italic: "",
      alignment: "center",
      font_size: 18,
      text_color: "#00ffffff", //cyan
      outline_color : "#000000ff",
      font_family: "Righteous",
      background_color: "#00000000",
    },
    {
      bold: "",
      italic: "",
      alignment: "center",
      font_size: 19,
      text_color: "#ffffffff", //white
      outline_color : "#000000ff",
      font_family: "RussoOne",
      background_color: "#00000000",
    },
  ]

  //const randomSubtitleTemplate = subtitleTemplates[Math.floor(Math.random() * subtitleTemplates.length)];
  function getSubtitleTemplates(templates) {
    const shuffled = [...templates].sort(() => 0.5 - Math.random());
  
    const [templateA, templateB, templateC, templateD, templateE, templateF, templateG, ] = shuffled.slice(0, 7);
  
    return [
      templateA,
      templateB,
      templateC,
      templateD,
      templateE,
      templateF,
      templateG,
    ];
  }

  const silenceBuffer = 100;
  const creatingChapterProject = async (idx, chapterData, subtitleTemplate) => {
    if (isAiShortModalActivated) return;
  
    let newVideosItems = {};
    const newJSONData = cloneDeep(ProjectJSON);
    let initStartTime = 0;
  
    let assets = Object.assign({}, ProjectJSON.asset);
    let assetKeys = Object.keys(assets);
    const selectedAsset = assets[assetKeys[0]];
  
    const videos = ProjectJSON.videos;
    const videoKeys = Object.keys(videos);
    let videoItem = videos[videoKeys[0]];
  
    const stampItem = chapterData.new_timestamps[0];
    const startTime = parseFloat(stampItem.split('-')[0]) * 1000;
    const endTime = parseFloat(stampItem.split('-')[1]) * 1000;
  
    const newItemId = uuidv4();
    const newVideoItem = cloneDeep(videoItem);
    newVideoItem.segment_start = startTime - newVideoItem.timeline_start - silenceBuffer > 0
      ? startTime - newVideoItem.timeline_start - silenceBuffer
      : 0;
    newVideoItem.segment_end = endTime - newVideoItem.timeline_start + silenceBuffer;
    newVideoItem.duration = newVideoItem.segment_end - newVideoItem.segment_start;
    newVideoItem.timeline_start = initStartTime;
    newVideoItem.timeline_end = newVideoItem.timeline_start + newVideoItem.duration;
    newVideoItem.signed_url = selectedAsset.signed_url;
    initStartTime = newVideoItem.timeline_end;
  
    const ratioWH = newVideoItem.dimension.h / newVideoItem.dimension.w;
    const H = 1080;
    if (newVideoItem.dimension.w > newVideoItem.dimension.h) {
      // Landscape
      newVideoItem.dimension = {
        w: (newVideoItem.dimension.w / newVideoItem.dimension.h) * H,
        h: H
      };
    } else {
      // Portrait or Square
      newVideoItem.dimension = {
        w: 1080,
        h: ratioWH * 1080
      };
    }
    newVideoItem.coordinate.x = 0;
    newVideoItem.coordinate.y = 0;
    // newVideoItem.ratioWH = { w: 1920, h: 1080 };
  
    newVideosItems = { ...newVideosItems, [newItemId]: newVideoItem };
  
    let newTextsItems = {};
    let textGroupId = uuidv4();
    let subtitleCount = 0;

    let is_portrait = ProjectJSON.width < ProjectJSON.height;
    let fontsize = is_portrait ? 20 : 15;
    let text_y_position = is_portrait ? 1300 : 680;
    let title_y_position = is_portrait ? 1600 : 850;
    let titlepart_y_position = is_portrait ? 1670 : 900;
  
    if (chapterData.translated_sentences) {
      console.log("There are translated sentences in project. startTime : ", startTime, "endTime : ", endTime);
      for (const [key, sentenceObject] of Object.entries(chapterData.translated_sentences)) {
        const sentence_start = sentenceObject.start * 1000;
        const sentence_end = sentenceObject.end * 1000;
        if ((sentence_start < startTime && sentence_end < startTime) || (sentence_start > endTime && sentence_end > endTime)) continue;
        console.log("creatingChapterProject start: ", sentence_start, "end: ", sentence_end, "sentence: ", sentenceObject.sentence);

        const projectTitleFontTemplate = {
          bold: "",
          italic: "",
          alignment: "center",
          font_size: fontsize,
          text_color: "#ffffffff", //white
          outline_color : "#000000ff",
          font_family: "AlfaSlabOne",
          background_color: "#00000000",
        };

        // const newSentence = sentenceObject.sentence.split(' ').map((word, i, arr) => (i + 1) % 3 === 0 && i < arr.length - 1 ? `${word} ?entered!*-` : word).join(' ');

        const charLimit = 18;
        const delimiter = "?entered!*-";
        const words = sentenceObject.sentence.split(' ');

        let lines = [];
        let currentLine = "";

        words.forEach((word) => {
            // Check if adding this word (and a space) exceeds the limit
            const testLine = currentLine === "" ? word : `${currentLine} ${word}`;

            if (testLine.length <= charLimit) {
                currentLine = testLine;
            } else {
                // Line is full, push it and start a new one with the current word
                if (currentLine !== "") {
                    lines.push(currentLine);
                }
                currentLine = word;
            }
        });

        // Push the final remaining line
        if (currentLine !== "") {
            lines.push(currentLine);
        }

        // Join lines with your custom marker
        const newSentence = lines.join(" " + delimiter);


        console.log("newSentence", newSentence);
  
        const property = {
          context: newSentence,
          properties: projectTitleFontTemplate,
        }

        const {
          alpha,
          context,
          contextutf16,
          coordinate,
          dimension,
          groups,
          is_flipped,
          metadata,
          metadatautf16,
          properties,
          ratioWH,
          rotation,
          sequence,
          transition
        } = await getNewTextInformation(property, ProjectJSON, textGroupId, 1);

        const newSubtitleItemId = uuidv4();
        const subtitleitem_timeline_start = (subtitleCount == 0) ? 0 : sentence_start - startTime;
        const subtitleitem_timeline_end   = sentence_end - startTime;

        console.log("subtitleitem_timeline_start : ", subtitleitem_timeline_start, " subtitleitem_timeline_end : ", subtitleitem_timeline_end, " for sentence : ", newSentence);

        const newSubtitleItem = {
          groups,
          alpha,
          context: newSentence,
          contextutf16: convertStringtoWStringUTF16(newSentence),
          metadata,
          metadatautf16,
          is_flipped,
          subtitle_uuid: subtitleUUID,
          timeline_start: subtitleitem_timeline_start,
          timeline_end: subtitleitem_timeline_end,
          duration: sentence_end - sentence_start,
          rotation,
          sequence: subtitleCount,
          properties,
          transition,
          dimension,
          coordinate: {...coordinate, y: text_y_position},
          ratioWH,
          is_subtitle: true
        };
    
        newTextsItems[newSubtitleItemId] = newSubtitleItem;
        subtitleCount         ++;
      }

    } else {
      for (const subtitleDataItem of subtitleData) {
        const isVisible = subtitleDataItem.start < endTime && subtitleDataItem.end > startTime;

        if (!isVisible) continue;
    
        const property = {
          context: subtitleDataItem.text,
          properties: subtitleTemplate,
        }
        
        const {
          alpha,
          context,
          contextutf16,
          coordinate,
          dimension,
          groups,
          is_flipped,
          metadata,
          metadatautf16,
          properties,
          ratioWH,
          rotation,
          sequence,
          transition
        } = await getNewTextInformation(property, ProjectJSON, textGroupId, 1);
    
        const newSubtitleItemId = uuidv4();
        const subtitleitem_timeline_start = (subtitleCount == 0) ? 0 : subtitleDataItem.start - startTime;
        const subtitleitem_timeline_end   = subtitleDataItem.end - startTime;
        const newSubtitleItem = {
          groups,
          alpha,
          context,
          contextutf16,
          metadata,
          metadatautf16,
          is_flipped,
          subtitle_uuid: subtitleUUID,
          timeline_start: subtitleitem_timeline_start,
          timeline_end: subtitleitem_timeline_end,
          duration: subtitleitem_timeline_end - subtitleitem_timeline_start,
          rotation,
          sequence: subtitleCount,
          properties,
          transition,
          dimension,
          coordinate: {...coordinate, y: text_y_position},
          ratioWH,
          is_subtitle: true
        };
    
        newTextsItems[newSubtitleItemId] = newSubtitleItem;
        subtitleCount         ++;
      }
    }

    // Adding project title text
    if(hasTitle){
      let titletextGroupId = uuidv4();
      const projectTitleFontTemplate = {
        bold: "",
        italic: "",
        alignment: "center",
        font_size: 10,
        text_color: "#ffffffff", //white
        outline_color : "#000000ff",
        font_family: "AlfaSlabOne",
        background_color: "#00000000",
      };
      const property = {
        context: convertStringWithDelimiter(ProjectJSON.title),
        properties: projectTitleFontTemplate,
      }

      const {
        alpha,
        context,
        contextutf16,
        coordinate,
        dimension,
        groups,
        is_flipped,
        metadata,
        metadatautf16,
        properties,
        ratioWH,
        rotation,
        titlesequence,
        transition
      } = await getNewTextInformation(property, ProjectJSON, titletextGroupId, 1);

      const titleTextItemId = uuidv4();
      const titleTextItem = {
        groups,
        alpha,
        context,
        contextutf16,
        metadata,
        metadatautf16,
        is_flipped,
        subtitle_uuid: null,
        timeline_start: 0,
        timeline_end: newVideoItem.duration,
        duration: newVideoItem.duration,
        rotation,
        sequence: titlesequence,
        properties,
        transition,
        dimension,
        coordinate: {...coordinate, y: title_y_position},
        ratioWH,
        is_subtitle: true
      };
  
      newTextsItems[titleTextItemId] = titleTextItem;
    }

    // Add Part text idx
    if(hasPart){
      let titletextGroupId = uuidv4();
      const projectTitleFontTemplate = {
        bold: "",
        italic: "",
        alignment: "center",
        font_size: 10,
        text_color: "#ffffffff", //white
        outline_color : "#000000ff",
        font_family: "AlfaSlabOne",
        background_color: "#00000000",
      };
      const property = {
        context: "Part " + (idx + 1),
        properties: projectTitleFontTemplate,
      }

      const {
        alpha,
        context,
        contextutf16,
        coordinate,
        dimension,
        groups,
        is_flipped,
        metadata,
        metadatautf16,
        properties,
        ratioWH,
        rotation,
        titlesequence,
        transition
      } = await getNewTextInformation(property, ProjectJSON, titletextGroupId, 1);

      const titleTextItemId = uuidv4();
      const titleTextItem = {
        groups,
        alpha,
        context,
        contextutf16,
        metadata,
        metadatautf16,
        is_flipped,
        subtitle_uuid: null,
        timeline_start: 0,
        timeline_end: newVideoItem.duration,
        duration: newVideoItem.duration,
        rotation,
        sequence: titlesequence,
        properties,
        transition,
        dimension,
        coordinate: {...coordinate, y: titlepart_y_position},
        ratioWH,
        is_subtitle: true
      };
  
      newTextsItems[titleTextItemId] = titleTextItem;
    }

  
    newJSONData.width       = ProjectJSON.width;
    newJSONData.height      = ProjectJSON.height;
    newJSONData.title       = `Reel ${chapterData.topic} - ${ProjectJSON.title} - Part ${idx + 1}`;
    newJSONData.videos      = newVideosItems;
    newJSONData.text        = newTextsItems;
  
    const totalTime         = await getTotalProjectTime(newJSONData);
    newJSONData.duration    = totalTime;

    const newProjectType    = 1; // AI_REELS
    const result            = await duplicatePrjoectJSON(projectUUID, newJSONData, newProjectType);
    const resData           = result.data;
    const duplicateUUID     = resData["Duplicated Project uuid"];
    const genProjectRes     = await getProjectJSON(duplicateUUID);
    const projUUID          = Object.keys(genProjectRes.data)[0];

    console.log("Final project :", newJSONData);
  
    return {
      projID: projUUID,
      data: genProjectRes.data[projUUID]
    };
  };

  // Only show and process 3 chapters at a time, add next when one finishes
  const [activeChapters, setActiveChapters] = useState([]); // keys of active/visible chapters
  const [startedChapters, setStartedChapters] = useState([]); // keys of started chapters
  const exportingRef = useRef(new Set()); // track which chapters are being exported

  // Only reset activeChapters/startedChapters if chapterTopics actually change (not just modal open/close)
  const prevChapterTopicsRef = useRef([]);
  useEffect(() => {
    // Only reset if chapterTopics changed (not just modal open/close)
    const topicsChanged =
      chapterTopics.length !== prevChapterTopicsRef.current.length ||
      chapterTopics.some((t, i) => t !== prevChapterTopicsRef.current[i]);
    if (chapterTopics.length > 0 && topicsChanged) {
      setActiveChapters(chapterTopics.slice(0, 1));
      setStartedChapters([]);
      prevChapterTopicsRef.current = chapterTopics;
    }
  }, [chapterTopics]);

  const handleStartAiShort = async (aishort_uuid, aishort_model_state, progress_text) => {
    let info = {
      title : ProjectJSON.title,
      lang  : languageToList1.find(l => l.key === languageInitials)?.label || "English",
      lang_initials : languageInitials,
      target_lang : languageToList1.find(l => l.key === subtitlesTargetLanguage)?.label || "English",
      target_lang_initials : subtitlesTargetLanguage,
      asset_uuid: assetUUID,
      config : { },
      started_at : new Date().toISOString(),
      state : aishort_model_state, // "PROCESSING"
      progress_text : progress_text || "Thinking..",
      progress : 1,
    };

    console.log("handleStartAiShort info : ", info);

    let aishortmanifestget_result = await AIShortManifestPost(aishort_uuid, info);

    console.log("AI Short Manifest Result : ", aishortmanifestget_result);

    aishortmanifestget_result.data.title = ProjectJSON.title;
    aishortmanifestget_result.data.lang = languageInitials;
    // aishortmanifestget_result.data.lang_initials = languageCodes[language] || "en";
    aishortmanifestget_result.data.target_lang = subtitlesTargetLanguage;
    // aishortmanifestget_result.data.target_lang_initials = languageCodes[subtitlesTargetLanguage] || "en";
    aishortmanifestget_result.data.config = { };
    aishortmanifestget_result.data.started_at = new Date().toISOString();
    aishortmanifestget_result.data.state = 5; // "PROCESSING"
    aishortmanifestget_result.data.progress = 1;

    return { aishortmanifestget_result };
  };

  const initManifest = async () => {
  // If we already have the result, return it
  if (manifestResultRef.current) return manifestResultRef.current;

  // If a request is already in progress, wait for THAT same promise
  if (!manifestPromiseRef.current) {
    manifestPromiseRef.current = handleStartAiShort(null, 5).then(res => { // "PROCESSING"
      manifestResultRef.current = res.aishortmanifestget_result;
      return res.aishortmanifestget_result;
    });
  }

  return await manifestPromiseRef.current;
};

useEffect(() => {
  const selectedTemplates = getSubtitleTemplates(subtitleTemplates);
  activeChapters.forEach((chapterKey, idx) => {
    if (!startedChapters.includes(chapterKey) && !exportingRef.current.has(chapterKey)) {
      setStartedChapters(prev => [...prev, chapterKey]);
      exportingRef.current.add(chapterKey); 

      (async () => {

        if (!manifestResultRef.current) {
          await initManifest(); 
        }

        // 2. Access the Ref safely now that it's guaranteed to be set
        const manifest = manifestResultRef.current;
        console.log("Manifest is now ready:", manifest)

        if (AIShortUUID == null)
          setAIShortUUID(manifest.data.uuid);

        const index = Object.keys(chapterList).indexOf(chapterKey);

        if (subtitlesTargetLanguage !== languageInitials) {
          const translated_sentences = await translatingChapter(index, chapterList[chapterKey], selectedTemplates[idx % selectedTemplates.length]);
        }

        const resData = await creatingChapterProject(index, chapterList[chapterKey], selectedTemplates[idx % selectedTemplates.length]);

        // EXAMPLE: Use the uuid from the manifest
        let info = { ... manifest.data,
                    title: resData.data['title'],  // New title for the chapter project
                    start_time: chapterList[chapterKey].start,      // Mapping from your chapter object
                    end_time: chapterList[chapterKey].end,          // Mapping from your chapter object
                    importance: chapterList[chapterKey].importance, // Mapping from your chapter object
                    state: 0, // "CREATED",                   // Default state
                    project_uuid: resData.projID,       // Available after creatingChapterProject
                    export_uuid: null,                  // Will be updated during/after exporting
                    aishort_uuid: manifest.data.uuid,    // Linking to parent
                    manifest : { sentences: chapterList[chapterKey].chapterSentences,
                                translated_sentences: subtitlesTargetLanguage !== languageInitials ? chapterList[chapterKey]?.translated_sentences : null
                                }
                  };

        let aishortitemmanifest_result = await AIShortItemManifestPost(manifest.data.uuid, null, info);

        info = { ...info, item_uuid: aishortitemmanifest_result.data.uuid };

        setChapterProject(prev => ({ ...prev, [chapterKey]: resData }));
        await exportingChapter(resData, chapterKey, info);
      })();
    }
  });
  // Added manifestResultRef.current to the deps so it kicks off 
  // as soon as the manifest finishes loading.
}, [activeChapters, startedChapters, chapterList, manifestResultRef.current]);

  useEffect(() => {
    // Always keep up to 3 active chapters, removing all finished and adding new ones as needed
    if (chapterTopics.length === 0 || activeChapters.length === 0) return;
    const maxChapters = aiShortsNumber || 20;
    const allChapters = chapterTopics.slice(0, maxChapters);
    // Remove all finished from activeChapters
    let newActive = activeChapters.filter(key => !chapterReExports[key]?.exported);
    // Add new chapters to fill up to 3
    const alreadyActive = new Set(newActive);
    for (let i = 0; i < allChapters.length && newActive.length < 1; i++) {
      const key = allChapters[i];
      if (!alreadyActive.has(key) && !chapterReExports[key]?.exported) {
        newActive.push(key);
        alreadyActive.add(key);
      }
    }
    // Remove from exportingRef any finished chapters
    activeChapters.forEach(key => {
      if (chapterReExports[key]?.exported) exportingRef.current.delete(key);
    });
    // Only update if changed
    if (JSON.stringify(newActive) !== JSON.stringify(activeChapters)) {
      setActiveChapters(newActive);
    }
    // If all done, set shortLoade
    const finishedCount = allChapters.filter(key => chapterReExports[key]?.exported === true).length;
    const totalCount = allChapters.length;
    const displayCount = totalCount === 0 ? 0 : Math.min(finishedCount + 1, totalCount);
    let progress_text = `(${displayCount} of ${totalCount})`;

    let info = {};
    info.progress_text = progress_text;
    const allDone = allChapters.every(key => chapterReExports[key]?.exported === true);
    if (allDone) {
      setShortLoaded(true);
      info.state = 6; // "SUCCESS"
      AIShortManifestUpdate(AIShortUUID, info); // "SUCCESS"
    } else {
      info.state = 5; // "PROGRESSING"
      AIShortManifestUpdate(AIShortUUID, info); // "PROGRESSING"
    }
  }, [chapterReExports, activeChapters, chapterTopics, aiShortsNumber]);


  //useEffect(()=> console.log("chapterTopics", chapterTopics), [chapterTopics])
  useEffect(() => {
    console.log("Direct AI Short Modal Mode: ", isDirectAIShort);
    if (modalOpen && modalData && modalData['chapters']) {
      const chapterData = modalData['chapters'];
      let tmpChapters = {};
      let chapterExports = {};
      let finalSelection = [];

      function parseTimestampRange(range) {
        const [start, end] = range.split('-').map(parseFloat);
        return { start, end };
      }

      console.log("Project Duration:", projectDuration, "isDirectAIShort:", isDirectAIShort);

      if (isDirectAIShort) {
        // Direct mode usually passes a single chapter object at key "0"
        const fullChapter = chapterData["0"] || Object.values(chapterData)[0];
        const { start, end } = parseTimestampRange(fullChapter.new_timestamps[0]);

        finalSelection = [{
          ...fullChapter,
          start,
          end,
          duration: end - start,
          importance: fullChapter.importance || "1.00",
          topic: (fullChapter.topic || ProjectJSON.title || "Full Video").trim(),
          // For full video, we treat the whole transcript as one sentence block
          chapterSentences: [{
            index: 1,
            start: start,
            end: end,
            sentence: (fullChapter.new_transcript || "").trim(),
          }],
        }];
      } else {
        function splitLongChaptersInto30sMax(chaptersArray, wordsAndTimestampsRaw) {
          // Safety check 1: Ensure raw text exists before trimming
          if (!wordsAndTimestampsRaw || typeof wordsAndTimestampsRaw !== 'string') return [];
          
          const lines = wordsAndTimestampsRaw.trim().split("\n");
          
          const wordData = lines.map(line => {
            const match = line.match(/^(.+?)\((\d+)\)-([\d.]+):([\d.]+)$/);
            if (!match) return null;
            const [, word, order, start, end] = match;
            return {
              word,
              order: parseInt(order),
              start: parseFloat(start),
              end: parseFloat(end),
              isSentenceEnd: /[.!?]$/.test(word) && !/\.\.\.$/.test(word) && !/,/.test(word),
            };
          }).filter(Boolean);

          const processed = [];

          for (const chapter of chaptersArray) {
            const [startOrder, endOrder] = chapter.word_order.split(" ").map(Number);
            const chapterWords = wordData.filter(w => w.order >= startOrder && w.order <= endOrder);
            if (chapterWords.length === 0) continue;

            const duration = chapterWords[chapterWords.length - 1].end - chapterWords[0].start;

            if (duration <= 30) {
              // Case 1: Chapter is already small enough. Treat the whole thing as one sentence/clip.
              const fullTranscript = (chapter.new_transcript || "").trim();
              processed.push({
                  ...chapter,
                  new_transcript: fullTranscript,
                  new_timestamps: [`${chapterWords[0].start}-${chapterWords[chapterWords.length - 1].end}`],
                  // NEW: Add sentence array for the single clip
                  chapterSentences: [{
                      sentence_index: 1,
                      start: chapterWords[0].start,
                      end: chapterWords[chapterWords.length - 1].end,
                      sentence: fullTranscript,
                  }],
              });
              continue;
            }

            // Case 2: Chapter needs to be split by sentence boundaries.
            let tempWords = [];
            let tempStart = null;

            for (let i = 0; i < chapterWords.length; i++) {
              const w = chapterWords[i];
              if (tempWords.length === 0) tempStart = w.start;
              tempWords.push(w);

              const currentDuration = w.end - tempStart;

              if ((w.isSentenceEnd && currentDuration >= 10) || i === chapterWords.length - 1) {
                  const sentenceTranscript = tempWords.map(t => t.word).join(" ");

                  processed.push({
                    ...chapter,
                    new_transcript: sentenceTranscript,
                    word_order: `${tempWords[0].order} ${tempWords[tempWords.length-1].order}`,
                    new_timestamps: [`${tempStart}-${w.end}`],
                    // NEW: Add sentence array for the sentence-level clip
                    chapterSentences: [{
                          index: processed.length + 1, // Temporary index, will be reset in combine
                          start: tempStart,
                          end: w.end,
                          sentence: sentenceTranscript,
                    }],
                  });
                  tempWords = [];
              }
            }
          }
          return processed;
        }



        const atomicClips = splitLongChaptersInto30sMax(Object.values(chapterData), textWithDetails.words_and_timestamps)
          .map(c => {
            const { start, end } = parseTimestampRange(c.new_timestamps[0]);
            return { ...c, start, end, duration: end - start };
          })
          .sort((a, b) => a.start - b.start);

        const combinedChapters = [];
        let buffer = [];

        for (const clip of atomicClips) {
          buffer.push(clip);

          const bufferStart = buffer[0].start;
          const bufferEnd = buffer[buffer.length - 1].end;
          const bufferDuration = bufferEnd - bufferStart;

          if (bufferDuration > aiShortsDuration) {

            // SAFETY FIX HERE: Use || "" to ensure no nulls are passed to the UI
            const mergedTranscript = buffer.map(c => (c.new_transcript || "").trim()).join(' ');
            const mergedTopic = buffer[0].topic || "";
            const mergedComment = buffer[0].comment || "";

            // NEW: Combine all 'chapterSentences' from the buffer clips
            let combinedSentences = [];
            buffer.forEach(c => {
              // Concatenate the sentences from each atomic clip
              if (c.chapterSentences) {
                  combinedSentences.push(...c.chapterSentences);
              }
            });

            // NEW: Re-index the sentences sequentially for the final chapter
            let finalSentences = combinedSentences.map((s, index) => ({
                index: index + 1,
                start: s.start,
                end: s.end,
                sentence: s.sentence,
            }));

            combinedChapters.push({
              start: bufferStart,
              end: bufferEnd,
              duration: bufferDuration,
              importance: buffer.reduce((sum, c) => sum + (parseFloat(c.importance) || 0), 0).toFixed(2),
              new_transcript: mergedTranscript,
              topic: mergedTopic,
              comment: mergedComment,
              new_timestamps: [`${bufferStart.toFixed(2)}-${bufferEnd.toFixed(2)}`],
              // FINAL ADDITION: JSON structure
              chapterSentences: finalSentences,
            });

            buffer = [];
          }
        }

        finalSelection = combinedChapters.slice(0, aiShortsNumber);
      }

      finalSelection.forEach(chapter => {
        const safeTopic = (chapter.topic || "Topic").trim(); 
        const key = `${safeTopic}-${chapter.start.toFixed(2)}`;
        tmpChapters[key] = chapter;
        chapterExports[key] = {exported: false,progress: 0, videoUrl: '',asset_uuid: null,shareUrl: ''};
      });

      setChapterList(tmpChapters);
      setChapterTopics(Object.keys(tmpChapters));
    }
  }, [modalData, modalOpen, aiShortsDuration, aiShortsNumber]);

     const settingExports = useCallback((exportData, keyItem) => {
        setChapterReExports(prev => {
          const prevData = prev[keyItem] || {};
          if (
            Object.keys(exportData).length === 1 &&
            Object.prototype.hasOwnProperty.call(exportData, "shareUrl")
          ) {
            return {
              ...prev,
              [keyItem]: {
                ...prevData,
                shareUrl: exportData.shareUrl,
              },
            };
          }

   
          if (prevData.exported === true) {
            return {
              ...prev,
              [keyItem]: {
                ...prevData,
                exported: true,
                progress: 100,
                videoUrl: prevData.videoUrl || exportData.videoUrl,
                asset_uuid: prevData.asset_uuid || exportData.asset_uuid,
                shareUrl: exportData.shareUrl ?? prevData.shareUrl,
              },
            };
          }

          const newProgress = Math.max(prevData.progress || 0, exportData.progress || 0);

          return {
            ...prev,
            [keyItem]: {
              ...prevData,
              ...exportData,
              progress: exportData.exported ? 100 : newProgress,
              exported: exportData.exported ?? prevData.exported ?? false,
            },
          };
        });
      }, []);

      const generateShareLinkForShort = useCallback(
        async (assetUuid, chapterKey) => {

          if (!assetUuid || !projectUUID) {
            console.error("[share][short] missing assetUuid/projectUUID", {
              assetUuid,
              projectUUID,
              chapterKey,
            });
            return null;
          }

          const uuid = assetUuid;
          if (!uuid) return;              //  asset uuid from url
          let shareUrl = "";

          try {
            const shareLinkResponse = await GetShareLink();
            let resp = null;
            if (shareLinkResponse.state === "success") {
              resp = await GetShareLink(shareLinkResponse.data.uuid, uuid);
              console.log("GetShareLink response:", resp, uuid);
              if (resp.share_link) {

              }
            } else {
              console.error("Failed to get share link:", shareLinkResponse);

              if (resp.state !== "success") {
                Swal.fire({
                  icon: "error",
                  title: "Share link could not be created",
                });
                return;
              }
            }

            shareUrl = resp.data?.share_link;

            if (!shareUrl) {
              console.error("Share URL not found in response", resp);
              Swal.fire({
                icon: "error",
                title: "Share link not found in response",
              });
              return;
            }

            const copy_res = copy(shareUrl);
            if (!copy_res) {
              Swal.fire({
                icon: "error",
                title: "Failed to copy link",
              });
              return;
            }

          } catch (err) {
            console.error("CreateSharedAssetLink error", err);
            Swal.fire({
              icon: "error",
              title: "Share link error",
              text: "An error occurred while creating share link.",
            });
          } finally {

          }

          settingExports({ shareUrl }, chapterKey);

          return shareUrl;
        },
        [settingExports, projectUUID]
      );


     

    const translatingChapter = async (idx, chapterProj, topic, retryCount = 0) => {
      const MAX_RETRIES = 3;
      const RETRY_DELAY = 2000;

      try {
        // 1. Initialize the translation session
        const initResponse = await getChatGPTLLMTranslation(null, false);
        if (initResponse.state !== 'success') throw new Error(`Init failed: ${initResponse.state}`);
        
        const uuid = initResponse.data.uuid;

        // --- REVISION START ---

        // 2. Prepare Subtitle Data from chapterProj
        // The source text for translation is now assumed to be in chapterProj.translated_sentences.
        // We expect this property to contain the detailed JSON structure:
        // [{ sentence_index: 1, start: X, end: Y, sentence: "Original Text" }, ...]

        // 3. Send to LLM with updated payload
        const sentencesAsObject = chapterProj.chapterSentences.reduce((acc, current) => {
        // 1. Get the index (or sentence_index) to use as the key
        const key = current.sentence_index || current.index; 
        
        // 2. Create a new object for the value, excluding the index key
        const value = { ...current };
        delete value.sentence_index; // Remove the key used for the property name
        delete value.index;
        
        // 3. Assign the object to the accumulator using the key
        acc[key] = value;
        return acc;
    }, {}); // Start with an empty object {}

    const jsonStringForTranslation = JSON.stringify(sentencesAsObject);
        const payloadObject = {
          target_lang: subtitlesTargetLanguage,
          text: jsonStringForTranslation
          // OPTIONAL (but helpful for context/tracking in the API):
        };
        let payload = JSON.stringify(payloadObject);

        await postChatGPTLLMTranslation(uuid, subtitlesTargetLanguage, payload);
        console.log(`✅ Translation started for UUID: ${payload}`);

        // 4. Poll for completion
        let checkResponse = await getChatGPTLLMTranslation(uuid, true);
        let translationResult = null;

        while (checkResponse.data.state_text !== 'SUCCESS') {
          await new Promise(resolve => setTimeout(resolve, 1000)); // Wait 1s

          checkResponse = await getChatGPTLLMTranslation(uuid, true);
          console.log(`✅ Translation pending for UUID: ${JSON.stringify(checkResponse, null, 2)}`);

          if (checkResponse.data?.state_text === 'FAILED' || checkResponse.state === 'failed' || checkResponse.state === 'error'  ) {
            throw new Error("Translation status reported failed");
          }
        }

        // --- REVISION END ---

        // 5. Update chapterProj with the completed translation result
        const outerResponse = JSON.parse(checkResponse.data.response);
        const finalSentencesObject = JSON.parse(outerResponse.text);

        chapterProj.translated_sentences = finalSentencesObject;


        console.log(`✅ Translation completed for: ${JSON.stringify(chapterProj, null, 2)}`);
        return translationResult;

      } catch (err) {
        console.warn(`❌ Attempt ${retryCount + 1} failed:`, err);

        if (retryCount < MAX_RETRIES) {
          const nextDelay = RETRY_DELAY * Math.pow(2, retryCount);
          console.log(`⏳ Retrying in ${nextDelay / 1000}s...`);
          
          await new Promise(resolve => setTimeout(resolve, nextDelay));
          return translatingChapter(idx, chapterProj, topic, retryCount + 1);
        } else {
          console.error("🚨 All retry attempts failed.");
          settingExports({ exported: false, progress: 0, videoUrl: null }, topic);
        }
      }
    };

    const exportingChapter = async (chapterProj, topic, info, retryCount = 0) => {
  const MAX_RETRIES = 3;
  const RETRY_DELAY = 2000; // ms

  const props = [chapterProj.projID, { w: 1080, h: 1920 }, 2, false, true];

  try {
    const response = await projectExportApi(...props);

    info = { ...info, export_uuid : response.data.export_uuid, };

    let aishortitemmanifest_result = await AIShortItemManifestPost(info.aishort_uuid, info.item_uuid, info);

    console.log("EXporting CHapter Info : ", info);

    if (response.state !== 'success') {
      throw new Error(`Export failed: ${response.state}`);
    }

    console.log(
      `✅ Export started successfully for ${chapterProj.projID} : `,
      response.data
    );

    const exportData = response.data;

    // 1) Normal page: asset_uuid comes, then poll with getAssetData
    if (exportData.asset_uuid) {
      loadingExportVideo(exportData.asset_uuid, topic, 1);
    }
    // 2) rare situation: backend directly returns signed_url
    else if (exportData.signed_url) {
      settingExports(
        {
          exported: true,
          progress: exportData.progress || 100,
          videoUrl: exportData.signed_url,
          asset_uuid: exportData.asset_uuid,
        },
        topic
      );
    }
   
    else {
      console.error("Unknown exportData shape", exportData);
      settingExports({ exported: false, progress: 0, videoUrl: null }, topic);
    }
  } catch (err) {
    console.warn(`❌ Export attempt ${retryCount + 1} failed`, err);

    if (retryCount < MAX_RETRIES) {
      const nextDelay = RETRY_DELAY * Math.pow(2, retryCount);
      console.log(`⏳ Retrying in ${nextDelay / 1000}s...`);

      await new Promise((resolve) => setTimeout(resolve, nextDelay));
      return exportingChapter(chapterProj, topic, info, retryCount + 1);
    } else {
      console.error("🚨 All retry attempts failed for", chapterProj.projID);
      settingExports({ exported: false, progress: 0, videoUrl: null }, topic);
    }
  }
};

    
  const loadingExportVideo = async (uuid, topic, attempt = 1) => {
  const MAX_ATTEMPTS = 200;

  if (attempt > MAX_ATTEMPTS) {
    console.error(`[${topic}] Gave up after ${MAX_ATTEMPTS} attempts.`);
    return;
  }

  try {
    const response = await getAssetData(uuid);

    if (response?.state === 'success') {
      const webHookData = response.data;

      if (webHookData?.signedurl) {
        
        settingExports(
          {
            exported: true,
            progress: webHookData.progress,
            videoUrl: webHookData.signedurl,
            asset_uuid: uuid,
          },
          topic
        );

        console.log(`[${topic}] Export complete.`);
        return;
      } else {
       
        settingExports(
          {
            exported: false,
            progress: webHookData.progress || 0,
            videoUrl: '',
            asset_uuid: uuid,
          },
          topic
        );
        console.log(
          `[${topic}] Export in progress... ${webHookData.progress || 0}%`
        );
      }
    }

    const delay = 10000;
    console.log(
      `[${topic}] Retry ${attempt}/${MAX_ATTEMPTS} in ${delay / 1000}s...`
    );
    setTimeout(() => loadingExportVideo(uuid, topic, attempt + 1), delay);
  } catch (err) {
    const delay = 10000;
    console.error(
      `[${topic}] Error: ${err.message}. Retrying in ${delay / 1000}s...`
    );
    setTimeout(() => loadingExportVideo(uuid, topic, attempt + 1), delay);
  }
};


  const onClickOpenProject = (choosedModal, choosedProjectUUID) => {
    if(choosedProjectUUID){
      window.open(`/edit/${choosedProjectUUID}`, '_blank');
    }
  };

  const countWords = (str) => {
    if (typeof str !== 'string') return 0;
    return str.trim().split(/\s+/).filter(word => word.length > 0).length;
  }

  function calculateDuration(timeIntervals) {
    // Ensure we have an array to work with, even if it's a single interval

    //console.log("timeIntervals : " + timeIntervals);
    const intervalsArray = Array.isArray(timeIntervals) ? timeIntervals : timeIntervals.split(',');

    //console.log("intervalsArray : " + intervalsArray);

    let totalDuration = 0;

    intervalsArray.forEach(interval => {
        const [start, end] = interval.split('-').map(Number);
        totalDuration += (end - start);
    });

    return totalDuration.toFixed(2);
  }

  const onDownloadShort = (videoUrl) => {
    const aElement = document.createElement('a');
    aElement.setAttribute('download', 'downloadVideo');
    aElement.href = videoUrl;
    aElement.setAttribute('target', '_blank');
    aElement.click();
    // URL.revokeObjectURL(href);
  }

  const openInstagramPopup = () => {
    const clientId = "1000779405531865"
    const redirectUri = "https://developmentapi.kedy.ai/api/v1/oauth/instagram/callback";
    const scope = "instagram_basic,instagram_content_publish,pages_show_list,pages_read_engagement";
    const authUrl = `https://www.facebook.com/v21.0/dialog/oauth?client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&scope=${scope}&response_type=code`;

    // Center the popup on screen
    const width = 600;
    const height = 700;
    const left = (window.innerWidth - width) / 2 + window.screenX;
    const top = (window.innerHeight - height) / 2 + window.screenY;

    // Open as popup instead of redirecting the main window
    window.open(
      authUrl,
      "InstagramLoginPopup",
      `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=yes`
    );
  };

  const [instagramModalOpen, setInstagramModalOpen] = useState(false);
  const [activeAssetUUID, setActiveAssetUUID] = useState(null);
  const [facebookModalOpen, setFacebookModalOpen] = useState(false);

  // const openInstagramUploadModal = (asset_uuid) => {

  //   const handleInstagramModalOpen = () => {
  //     setInstagramModalOpen(true);
  //   };

  //   const handleInstagramModalClose = () => {
  //     setInstagramModalOpen(false);
  //   };

  //   const handlePublishToInstagram = () => {
  //     console.log("Publishing to Instagram with description:", instagramDescription);
  //     // Add your logic to publish to Instagram here
  //     onUploadInstagram(asset_uuid);
  //     handleInstagramModalClose();
  //   };

  //   return (
  //     <>
  //     <Dialog
  //       open={instagramModalOpen}
  //       onClose={handleInstagramModalClose}
  //       aria-labelledby="instagram-dialog-title"
  //       aria-describedby="instagram-dialog-description"
  //       maxWidth="sm"
  //       fullWidth
  //     >
  //       <DialogTitle id="instagram-dialog-title">Publish to Instagram</DialogTitle>
  //       <DialogContent>
  //       <TextField
  //         label="Instagram Description"
  //         multiline
  //         rows={4}
  //         fullWidth
  //         value={instagramDescription}
  //         onChange={(e) => setInstagramDescription(e.target.value)}
  //         variant="outlined"
  //       />
  //       </DialogContent>
  //       <DialogActions>
  //       <Button onClick={handleInstagramModalClose}>Cancel</Button>
  //       <Button onClick={handlePublishToInstagram} variant="contained" color="primary">
  //         Publish
  //       </Button>
  //       </DialogActions>
  //     </Dialog>
  //     <Button onClick={handleInstagramModalOpen} variant="contained" color="primary">
  //       Open Instagram Upload Modal
  //     </Button>
  //     </>
  //   );
  // };

  const openInstagramUploadModal = useCallback(
    (uuid) => {
      if (!instagramAccounts || instagramAccounts.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "No Instagram account",
          text: "You need to connect at least one Instagram account in the settings first.",
        });
        return;
      }
      setActiveAssetUUID(uuid);
      setInstagramModalOpen(true);
    },
    [instagramAccounts]
  );
  

  const onUploadInstagram = async (asset_uuid, opts = {}) => {
    const {
      publishDate,
      publishTime,
      instagramDescription,
      instagramUsername,
    } = opts;
  const rawDescription = instagramDescription || "";
  const safeDescription = rawDescription.slice(0, INSTAGRAM_DESCRIPTION_LIMIT);

    if (!asset_uuid) return;

    if (!instagramUsername) {
      Swal.fire({
        icon: "error",
        title: "Account not selected",
        text: "Please select an Instagram account.",
      });
      return;
    }

    if (!publishDate || !publishTime) {
      Swal.fire({
        icon: "error",
        title: "Missing date/time",
        text: "Please select a valid date and time.",
      });
      return;
    }

    const instagramDatetime = new Date(`${publishDate}T${publishTime}:00`);

    console.log(
      `Uploading to Instagram -> username: ${instagramUsername}, asset: ${asset_uuid}, desc: ${instagramDescription}, datetime: ${instagramDatetime.toISOString()}`
    );

    try {
      await uploadtoInstagram(
        asset_uuid,
        instagramUsername,
        safeDescription,
        instagramDatetime
      );

      Swal.fire({
        icon: "success",
        title: "Send to Instagram",
      });
    } catch (e) {
      console.error("uploadtoInstagram error", e);
      
      Swal.fire({
        icon: "error",
        title: "Upload failed",
        text: "An error occurred while uploading to Instagram.",
      });
    }
  };
//   const onUploadFacebook = async (asset_uuid, opts = {}) => {
//   const {
//     publishDate,
//     publishTime,
//     facebookDescription,
//     facebookPage, // veya pageId, backend ne bekliyorsa
//   } = opts;

//   const rawDescription = facebookDescription || "";
//   const safeDescription = rawDescription.slice(0, INSTAGRAM_DESCRIPTION_LIMIT); // aynı limit iş görür

//   if (!asset_uuid) return;

//   if (!facebookPage) {
//     Swal.fire({
//       icon: "error",
//       title: "Sayfa seçilmedi",
//       text: "Lütfen bir Facebook sayfası seç.",
//     });
//     return;
//   }

//   if (!publishDate || !publishTime) {
//     Swal.fire({
//       icon: "error",
//       title: "Tarih / saat eksik",
//       text: "Lütfen geçerli bir tarih ve saat seç.",
//     });
//     return;
//   }

//   const facebookDatetime = new Date(`${publishDate}T${publishTime}:00`);

//   console.log(
//     `Uploading to Facebook -> page: ${facebookPage}, asset: ${asset_uuid}, desc: ${facebookDescription}, datetime: ${facebookDatetime.toISOString()}`
//   );

//   try {
//     // TODO: backend fonksiyon ismi sende farklı olabilir
//     await uploadToFacebook(
//       asset_uuid,
//       facebookPage,
//       safeDescription,
//       facebookDatetime
//     );

//     Swal.fire({
//       icon: "success",
//       title: "Facebook’a gönderildi",
//     });
//   } catch (e) {
//     console.error("uploadToFacebook error", e);

//     Swal.fire({
//       icon: "error",
//       title: "Yükleme başarısız",
//       text: "Facebook yüklemesinde bir hata oluştu.",
//     });
//   }
// };
// const handlePublishFacebook = useCallback(
//   (uuid, form) => {
//     onUploadFacebook(uuid, form);
//     setFacebookModalOpen(false);
//   },
//   [onUploadFacebook]
// );

  //   const pd = opts.publishDate ?? publishDate;
  //   const pt = opts.publishTime ?? publishTime;
  //   const desc = opts.instagramDescription ?? instagramDescription;

  //   const selectedDateTime = new Date(`${pd}T${pt}`);

  //   console.log("onUploadInstagram data form:", opts);
  //   console.log("Using instagramDescription:", desc);

  //   const apiKeyRes = await getApikeysConfig();

  //   const instagramAccounts = apiKeyRes.data?.config?.instagram || [];
  //   const firstAccount = instagramAccounts[0];
  //   const instagramUsername = firstAccount?.username || null;

  //   console.log(
  //       `instagramUsername: ${instagramUsername}, Asset UUID: ${asset_uuid}, instagramDescription: ${desc}`
  //   );

  //   const data = { publishDate: "2025-02-12", publishTime: "14:20" };
  //   const publishDate = "2025-01-01";
  //   const publishTime = "00:00";

  //   const instagramDatetime = new Date(`${pd}T${pt}:00`);
  //   console.log(instagramDatetime);

  //   const instagramDescription = desc;

  //   //if (instagramId && instagramId.length > 0 && instagramToken && instagramToken.length > 0) {
  //     uploadtoInstagram(asset_uuid, instagramUsername, instagramDescription, instagramDatetime);
  //   //  return true
  //   //} else {
  //   //  console.log("Missing Instagram credentials");
  //   //  openInstagramPopup();
  //     // optionally show an error or redirect user
  //   //}
  //   //}
  // };

  const handleCloseInstagramModal = useCallback(() => {
    setInstagramModalOpen(false);
  }, []);

  const handlePublishInstagram = useCallback(
  (uuid, form) => {
    onUploadInstagram(uuid, form);
    setInstagramModalOpen(false);
  },
  [onUploadInstagram]
);


  const handleOpenProject = useCallback((item, id) => {
    onClickOpenProject(item, id);
  }, [onClickOpenProject]);

  const handleDownloadShort = useCallback((url) => {
    onDownloadShort(url);
  }, [onDownloadShort]);

  const handleOpenInstagramModal = useCallback((uuid) => {
    openInstagramUploadModal(uuid);
  }, [openInstagramUploadModal]);

  const handleDuration = useCallback((timestamps) => {
    return calculateDuration(timestamps);
  }, [calculateDuration]);
    const handleCopyLink = useCallback((text, message) => {
    if (!text) return;

    try {
      const success = copy(text);
      if (!success) {
        Swal.fire({
          icon: "error",
          title: "Copy failed",
          text: "Links could not be copied to the clipboard.",
        });
        return;
      }
    } catch (e) {
      console.error("Clipboard write error", e);
      Swal.fire({
        icon: "error",
        title: "Copy failed",
        text: "Links could not be copied to the clipboard.",
      });
      return;
    }

    window.toastr.success(message || "Link copied to clipboard.");

  }, []);

    const handleCopyAllLinks = useCallback(() => {
    const exportsObj = chapterReExports || {};
   const exportedItems = Object.values(exportsObj).filter(
  (item) => item?.exported && item?.shareUrl
);




    if (!exportedItems.length) {
      Swal.fire({
        icon: "info",
        title: "There is no links to copy",
        text: "You need to wait for the short videos to be exported and share links to be generated.",
      });
      return;
    }

   
      const allLinksText = exportedItems
     .map((item) => item.shareUrl)   
     .join("\n");

    handleCopyLink(
      allLinksText,
      `${exportedItems.length} share links copied to clipboard.`
    );
  }, [chapterReExports, handleCopyLink]);

   const hasAnyExportedLink = Object.values(chapterReExports || {}).some(
  (item) =>
    item?.exported &&
    (item?.shareUrl || item?.videoUrl)
);


  // const onUploadInstagram = async (asset_uuid) => {

  //   const apiKeyRes = await getApikeysConfig();
  //   // if (apiKeyRes.state !== 'success') return;

  //   console.log("onUploadInstagram apiKeyRes :", apiKeyRes);

  //   const instagramId = apiKeyRes.data?.config?.instagram_id ? apiKeyRes.data?.config?.instagram_id : null;
  //   const instagramToken = apiKeyRes.data?.config?.instagram_access_token ? apiKeyRes.data?.config?.instagram_access_token : null;

  //   console.log(`Instagram ID: ${instagramId}, Token: ${instagramToken}, Asset UUID: ${asset_uuid}`);

  //   if (true) // (instagramId && instagramId.length > 0 && instagramToken && instagramToken.length > 0) 
  //   {
  //     console.log("Uploading to Instagram Modal Swal...");


  //     Swal.fire({
  //       title: 'Add Event',
  //       html: `
  //         <input id="desc" class="swal2-input" placeholder="Description">
  //         <input id="date" type="date" class="swal2-input">
  //       `,
               
  //       showCancelButton: true,
  //       backdrop: true,               // keep overlay
  //       allowOutsideClick: false,     // prevent parent modal closing
  //       allowEscapeKey: false,
  //       didOpen: () => {
  //         // Force focus back to Swal if anything tries to steal it
  //         const popup = Swal.getPopup();
  //         const interval = setInterval(() => {
  //           if (document.activeElement !== popup && popup) {
  //             popup.focus();
  //           }
  //         }, 100);

  //         // Clear interval when modal closes
  //         Swal.getConfirmButton().addEventListener('click', () => clearInterval(interval));
  //         Swal.getCancelButton().addEventListener('click', () => clearInterval(interval));
  //       },
  //     });
  //     // uploadtoInstagram(asset_uuid);
  //     //return true
  //   } else {
  //     console.log("Missing Instagram credentials");
  //     openInstagramPopup();
  //     // optionally show an error or redirect user
  //   }
  // };

  return (
  <>
    <Dialog
      open={modalOpen}
      onClose={onModalCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xl"
      PaperProps={{ style: { minHeight: '90dvh', overflowY: 'auto' } }}
      height="80vh"
      sx={{}}
      fullWidth={true}
      disableScrollLock
    >
      <DialogTitle id="alert-dialog-title">
        <Typography variant="body1" sx={{ textAlign: 'center', width: '100%' }}>
          Generated AI Shorts
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box>
          <ChaptersGrid
            chapterTopics={chapterTopics}
            chapterList={chapterList}
            chapterProject={chapterProject}
            chapterReExports={chapterReExports}
            onClickOpenProject={handleOpenProject}
            onDownloadShort={handleDownloadShort}
            setChapterReExports={setChapterReExports}
            openInstagramUploadModal={handleOpenInstagramModal}
            calculateDuration={handleDuration}
            onCopyLink={handleCopyLink}
            onGenerateShareLink={generateShareLinkForShort}
          />
        </Box>
        <Divider />
      </DialogContent>
            <DialogActions>
        <Button
          onClick={handleCopyAllLinks}
          disabled={!hasAnyExportedLink}
        >
          Get All Links
        </Button>
        <Button onClick={onModalCancel}>Cancel</Button>
      </DialogActions>

    </Dialog>

      <InstagramUploadDialog
  open={instagramModalOpen}
  onClose={handleCloseInstagramModal}
  activeAssetUUID={activeAssetUUID}
  onPublish={handlePublishInstagram}
  instagramAccounts={instagramAccounts}
/>

  </>
  

  );
};
